module.exports = __webpack_public_path__ + "fonts/DIN-Light.cbf9b417.otf";